import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const depRuleList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/departmentPoints/list?` + params,
        method: 'GET'
    })
}

export const editDepRule = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/departmentPoints/updatePoints`,
        method: 'PUT',
        data: params
    })
}
export const pointsDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/departmentPoints/pointsDetail/${id}`,
        method: 'GET'
    })
}